import { Link } from "react-router-dom";
import { useState } from "react";
import { X, Menu } from "lucide-react";
import logo from "../../assets/logo.svg";
import LoginLogo from "../../assets/logoMobile.svg";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const token = localStorage.getItem("token");
  const toggleMenu = () => setIsOpen(!isOpen);
  const navLinks = [
    { name: "Features", href: "#features" },
    { name: "How It Works", href: "#howitworks" },
    { name: "Integrations", href: "#integrations" },
    { name: "Contact", href: "#contact" },
  ];

  return (
    <nav className="bg-lightBlue text-white">
      <div className=" flex justify-between items-center px-4 md:px-8 lg:px-12  bg-lightBlue border-b ">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <img
            src={logo}
            alt="Ledgerate Logo"
            className="h-[70px] md:h-20 lg:h-[90px] -ml-4 block"
          />
        </div>
        <div className=" hidden md:flex lg:gap-10 items-center">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-white text-base font-raleway no-underline transition-colors hover:bg-lightGreen hover:text-blue px-4 py-2 rounded-md active:scale-105"
            >
              {link.name}
            </a>
          ))}
          {token ? (
            <>
              <Link
                key="dashboard"
                to="/portal/dashboard"
                className="text-white text-base font-raleway no-underline transition-colors hover:bg-lightGreen hover:text-blue px-4 py-2 rounded-md active:scale-105"
              >
                {"Dashboard"}
              </Link>
            </>
          ) : (
            <>
              <Link
                key="Sign Up"
                to="/portal/signup"
                className="text-white text-base font-raleway no-underline transition-colors hover:bg-lightGreen hover:text-blue px-4 py-2 rounded-md active:scale-105"
              >
                {"Sign Up"}
              </Link>
              <Link
                key="LogIn"
                to="/portal/login"
                className="text-white text-base font-raleway no-underline transition-colors hover:bg-lightGreen hover:text-blue px-4 py-2 rounded-md active:scale-105"
              >
                {"Log In"}
              </Link>
            </>
          )}
        </div>

        {/* Hamburger Menu - Mobile */}
        <button className="md:hidden focus:outline-none" onClick={toggleMenu}>
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className="md:hidden fixed inset-0 bg-lightGreen z-50 px-6 py-4">
          <div className="flex items-center justify-between mb-6">
            {/* Mobile Logo */}
            <div className="flex items-center space-x-2">
              <img src={LoginLogo} alt="Ledgerate" className=" block" />
            </div>

            {/* Close Icon */}
            <button onClick={toggleMenu}>
              <X size={28} className="text-white" />
            </button>
          </div>

          {/* Auth Buttons */}
          {token ? (
            <div className="flex space-x-4 mb-6">
              <Link
                to="/portal/dashboard"
                className="border border-lightBlue text-white px-4 py-1 rounded w-1/2 text-center active:scale-105"
              >
                Dashboard
              </Link>
            </div>
          ) : (
            <div className="flex space-x-4 mb-6">
              <Link
                to="/portal/login"
                className="border border-lightBlue text-lightBlue px-4 py-1 rounded w-1/2 text-center active:scale-105"
              >
                Login
              </Link>

              <Link
                to="/portal/signup"
                className="bg-lightBlue text-white px-4 py-1 rounded w-1/2 text-center active:scale-105"
              >
                Sign Up
              </Link>
            </div>
          )}
          {/* <div className="flex space-x-4 mb-6">
            <Link
              to="/portal/login"
              className="border border-lightBlue text-lightBlue px-4 py-1 rounded w-1/2 text-center active:scale-105"
            >
              Login
            </Link>

            <Link
              to="/portal/signup"
              className="bg-lightBlue text-white px-4 py-1 rounded w-1/2 text-center active:scale-105"
            >
              Sign Up
            </Link>
          </div> */}

          {/* Mobile Links */}
          <ul className="space-y-6  text-white text-4xl font-light pt-4 pb-12">
            {navLinks.map((link) => {
              return (
                <li key={link?.name} className="border-b pb-4 border-white">
                  <a className="py-4" href={link?.href} onClick={toggleMenu}>
                    {link?.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </nav>
  );
}
